import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
import { Collapsible } from './Collapsible';
import { tomos } from '../data/tomos';
export function TomosSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section id="contenido" className="w-full bg-cream px-4 py-11 sm:px-8 sm:py-16 lg:py-20" data-id="element-168" data-mp="1p5n443dxzmlt">
      <div className="mx-auto max-w-6xl" data-id="element-169" data-mp="1u4hovavgzl8k">
        <div className="max-w-3xl" data-id="element-170" data-mp="xdfpf8hzyka2">
          <p className="font-sans text-[11px] font-semibold uppercase tracking-[0.16em] text-gold-600 sm:text-sm sm:tracking-[0.18em]" data-id="element-171" data-mp="xeh0hcz0j6rs">
            Qué incluye
          </p>
          <h2 className="mt-2 font-display text-2xl font-extrabold leading-tight text-ink-900 sm:mt-3 sm:text-4xl" data-id="element-172" data-mp="16caw0loydwdw">
            7 tomos para trabajar la adolescencia de manera integral
          </h2>
          <p className="mt-2 font-sans text-sm text-ink-600 md:hidden" data-id="element-173" data-mp="2hrfzvt0tm0z3">
            Tocá cada tomo para ver qué incluye.
          </p>
        </div>

        <ol className="mt-6 grid grid-cols-1 gap-x-10 gap-y-px sm:mt-10 md:grid-cols-2" data-id="element-174" data-mp="2qo8idf91tkgj">
          {tomos.map((tomo, index) => {
          const isOpen = openIndex === index;
          return <li key={tomo.numero} className="border-t border-cream-300" data-id="element-175" data-mp="2hnk8mwqou69g" data-mpi={index}>
                <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} aria-controls={`tomo-panel-${index}`} className="grid w-full grid-cols-[auto_1fr_auto] items-center gap-3 py-3 text-left transition-colors duration-150 ease-out active:bg-cream-200 sm:gap-5 md:pointer-events-none md:items-start md:py-6" data-id="element-176" data-mp="2hpn59zmcixn5">
                  <span className="font-display text-2xl font-extrabold leading-none text-gold-600 sm:text-3xl" aria-hidden="true" data-id="element-177" data-mp="1tz0wu78fjbcm">
                    {tomo.numero}
                  </span>
                  <h3 className="font-display text-base font-bold leading-snug text-ink-900 sm:text-lg" data-id="element-178" data-mp="1k24oc1ij6p82">
                    <span className="sr-only" data-id="element-179" data-mp="1fb9bwczmjnxp">Tomo {tomo.numero}: </span>
                    {tomo.titulo}
                  </h3>
                  <ChevronDownIcon className={`h-5 w-5 shrink-0 text-ink-600 transition-transform duration-200 ease-out md:hidden ${isOpen ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-180" data-mp="11c9n95c4391j" />
                </button>

                <Collapsible id={`tomo-panel-${index}`} open={isOpen} className="md:hidden" data-id="element-181" data-mp="1y0pd72j4vkf6">
                  <p className="pb-4 pl-11 pr-8 font-sans text-sm leading-relaxed text-ink-700" data-id="element-182" data-mp="1obpbvch5scxt">
                    {tomo.descripcion}
                  </p>
                </Collapsible>

                <p className="hidden pb-6 pl-[3.4rem] font-sans text-base leading-relaxed text-ink-700 md:block" data-id="element-183" data-mp="2gs8dv2poqme1">
                  {tomo.descripcion}
                </p>
              </li>;
        })}
        </ol>
      </div>
    </section>;
}